<template>
  <v-container fluid class="px-0">
    <v-row class="align-end" dense>
      <v-col>
        <v-file-input
          v-if="!localFile.filename"
          accept=".xlsx"
          show-size
          hide-details
          @change="selectFile"
          :disabled="logView || !editMode"
          :loading="updating"
          label="Выберите файл Excel с листом, имя которого начинается с «МНН»"
        />
        <div v-else class="d-flex text-wrap align-end justify-lg-space-between">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                @click="downloadFile"
                v-bind="attrs"
                v-on="on"
                class="link blue--text font-italic"
              >
                <v-icon class="blue--text" left>mdi-file-excel-outline</v-icon
                >{{ localFile.filename }}
              </span>
            </template>
            <span
              >Скачать файл<v-icon color="white" right
                >mdi-download</v-icon
              ></span
            >
          </v-tooltip>
          <v-file-input
            v-if="!logView && editMode"
            class="justify-end"
            accept=".xlsx"
            hide-input
            show-size
            hide-details
            @change="selectFile"
            :loading="updating"
            title="Заменить файл Excel"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as Exceljs from 'exceljs'
import { parseTaLpWorkbook } from '@/components/expAnalogs/taLp/parseWorkbook'
import { copyObject } from '@/lib/objects'

export default {
  name: 'UpdateTaLp',
  props: {
    logView: {
      type: Boolean,
      default: false,
    },
    localFile: {
      type: Object,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    file: null,
    updating: false,
  }),
  computed: {
    ...mapGetters(['storedPlpId']),
  },
  methods: {
    ...mapActions(['CREATE_PLP_FILE', 'GET_PLP_FILE']),
    doChange(data, force = false) {
      this.$emit('change', data, force)
    },
    async downloadFile() {
      await this.GET_PLP_FILE(this.localFile)
    },
    async compileManual(changeFile = false) {
      const workbook = new Exceljs.Workbook()
      await workbook.xlsx.load(this.file)

      const { name, rows, note } = parseTaLpWorkbook(workbook)
      let localFile = null

      if (changeFile) {
        localFile = await this.CREATE_PLP_FILE({
          plp_id: this.storedPlpId,
          filename: this.file.name,
          file: this.file,
        })
      }

      this.doChange(
        {
          sheetName: name,
          rows: copyObject(rows),
          note,
          localFile,
        },
        true
      )
    },
    async selectFile(file) {
      this.file = file
      if (!this.file) return
      this.updating = true
      try {
        await this.compileManual(true)
      } catch (e) {
        this.$emit('parse-error', e.message || String(e))
      } finally {
        this.updating = false
      }
    },
  },
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
</style>
